<script>
import Chart from "@/components/income/IncomeChart";
import ApplicationIncomeChart from "@/components/application/ApplicationIncomeChart";
import IncomeTypeChart from "./income-type-chart";
/**
 * Dashboard component
 */
export default {
  components: {
    Chart,
    ApplicationIncomeChart,
    IncomeTypeChart,
  },
  data() {
    return {
      title: "درآمد",
      items: [
        {
          text: "درآمد",
          active: true,
        },
      ],
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <template>
      <div class="row">
        <div class="col-12">
          <chart />
        </div>
        <div class="col-md-6">
          <application-income-chart />
        </div>
        <div class="col-md-6">
          <income-type-chart />
        </div>
      </div>
    </template>
  </Layout>
</template>
